import React from "react";

import { ColumnProps, RowData } from "src/common/components/DataTable/types";
import { normalizeSearchString } from "src/common/utils/common";

export function useFilter(
	columns: ColumnProps[],
	data: RowData[],
	query: string
): RowData[] {
	return React.useMemo(() => {
		const normalizedQuery = normalizeSearchString(query);
		return data.filter(item =>
			columns.some(({ key, mapToString }) =>
				normalizeSearchString(
					mapToString ? mapToString(item[key]) : `${item[key]}`
				).includes(`${normalizedQuery}`)
			)
		);
	}, [columns, data, query]);
}
